import BanIPModal from './components/BanIPModal';
import UnbanIPModal from './components/UnbanIPModal';
import BannedIP from './models/BannedIP';

export default {
    'fof/ban-ips/components/BanIPModal': BanIPModal,
    'fof/ban-ips/components/UnbanIPModal': UnbanIPModal,
    'fof/ban-ips/models/BannedIP': BannedIP,
};
